
























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { statisticDetailTimes } from '@/constants/type-helper';
import { namespace } from 'vuex-class';
import { AcgnFormTitle } from '@/components/';
import { openUrl } from '@/util';
import {
  AcgnTable,
} from '@acgn/herm/src/ui';

const StatisticAction = namespace('desk/statistic').Action;
const StatisticGetter = namespace('desk/statistic').Getter;
import { DataTypesMixin } from '@/mixins';

@Component({
  components: {
    AcgnTable,
    AcgnFormTitle
  },
  mixins: [ DataTypesMixin ]
})

/**
 * 过审情况-管理方
 */
export default class AcgnAuditDetail extends Vue {

  @Prop({ default: null }) public comicId: number | null; // 项目id
  @Prop({ default: '' }) public exportCode: string; // 导出权限码

  @StatisticAction private getRetrialCycleAdminDetail: any;
  @StatisticGetter private loadings: any; // loading

  private selectOpts: any = statisticDetailTimes;
  private selectType: number = 2;

  private tableConfig: any = {
    columns: [
      {
        label: '项目',
        prop: 'time_slot',
        width: 200
      },
      {
        label: '提交审批',
        prop: 'subcnt',
        render: (h: any, { row }: any) => (this as any).renderLink(row, 'subcnt')
      },
      {
        label: '审批通过',
        prop: 'approve'
      },
      {
        label: '审批拒绝',
        prop: 'refuse'
      },
      {
        label: '过审率',
        prop: 'submit_rate'
      }
    ],
    data: []
  };

  private pageConfig: any = {}; // 分页数据
  private dataType: number = (this as any).comicId ? 2 : 1;
  private renderLink(row: any, key: string) {
    const name = row[key];
    const routeName = 'desk-statisticApproveComicDetail';
    if (this.comicId) {
      return (
        <acgn-permission to={{ name: routeName, params: { id: this.comicId, time: row.time_slot } }}>
          {name}
        </acgn-permission>
      );
    }
    return (
      <span>{name}</span>
    );
  }

  // table组件获取数据更新数据接口
  private async initSearh() {
    const { tableConfig, pageConfig } = this;
    const options = this.getSearchOptions();
    const { result } = await this.getRetrialCycleAdminDetail(options);
    tableConfig.data = result;
  }

  private getSearchOptions() {
    return {
      type: this.selectType,
      project_id: this.comicId,
      order: this.dataType > 0 ? 1 : 2,
      data_type: this.dataType
    };
  }

  private selectChange() {
    this.initSearh();
  }

  private exportExcel() {
    openUrl('/api/v1/workbench/retrialcycleofadmin?export=1', this.getSearchOptions());
  }
}
